import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import RoleAccessLayer from "../components/RoleAccessLayer";

const RoleAccessPage = () => {
  return (
    <>


        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Roles  </h5><Breadcrumb title="Roles" /></div>

        {/* RoleAccessLayer */}
        <RoleAccessLayer />


    </>
  );
};

export default RoleAccessPage; 
